module.exports = __webpack_public_path__ + "img/2bec5ac.png";